import React from 'react';
import { ListGroup, Badge } from 'react-bootstrap';
import { FaCalendarAlt, FaUserClock, FaDoorOpen, FaBriefcase, FaUserCheck } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ApprovalItem = ({ icon: Icon, title, count, color, onClick }) => {
  return (
    <ListGroup.Item
      className="d-flex justify-content-between align-items-center px-0 py-3"
      action
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="d-flex align-items-center">
        <div className={`bg-${color} bg-opacity-10 p-2 rounded me-3`}>
          <Icon className={`text-${color}`} size={20} />
        </div>
        <span>{title}</span>
      </div>
      <Badge bg={count > 0 ? color : 'secondary'} pill>
        {count}
      </Badge>
    </ListGroup.Item>
  );
};

const PendingApprovalsWidget = ({ data }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleItemClick = (type) => {
    let targetPath = '/wrms/approvals';
    if (user?.role === 'admin') {
      targetPath = '/leaves';
    } else if (user?.role === 'hr') {
      targetPath = '/wrms/admin';
    }
    navigate(targetPath, { state: { typeFilter: type } });
  };

  return (
    <div className="pending-approvals-content p-2 p-md-3 h-100">
      <ListGroup variant="flush">
        <ApprovalItem
          icon={FaCalendarAlt}
          title="Leave Requests"
          count={data?.wrmsPending?.leave || 0}
          color="warning"
          onClick={() => handleItemClick('leave')}
        />
        <ApprovalItem
          icon={FaUserClock}
          title="Early Leaves"
          count={data?.wrmsPending?.early_leave || 0}
          color="info"
          onClick={() => handleItemClick('early_leave')}
        />
        <ApprovalItem
          icon={FaDoorOpen}
          title="Gate Passes"
          count={data?.wrmsPending?.gate_pass || 0}
          color="danger"
          onClick={() => handleItemClick('gate_pass')}
        />
        <ApprovalItem
          icon={FaBriefcase}
          title="Extra Work Entries"
          count={data?.wrmsPending?.extra_work || 0}
          color="success"
          onClick={() => handleItemClick('extra_work')}
        />
        <ApprovalItem
          icon={FaUserCheck}
          title="Document Verifications"
          count={data?.documents || 0}
          color="primary"
          onClick={() => navigate('/employees', { state: { filter: 'incomplete' } })}
        />
      </ListGroup>

      {data?.overdue && data.overdue.length > 0 && (
        <div className="mt-4 p-3 badge-soft-danger rounded-4 d-flex align-items-center">
          <small className="fw-bold">
            Attention: {data.overdue.length} approvals are overdue
          </small>
        </div>
      )}
    </div>
  );
};

export default PendingApprovalsWidget;
